export const ORDERS_ACTION_TYPES = {
  setList: 'orders-set-list',
  setListCount: 'orders-set-list-count',
};